var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNGflagSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1679_4350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 -1.04907e-06C5.37259 -1.62846e-06 1.62846e-06 5.37258 1.04907e-06 12C4.69686e-07 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 -4.69686e-07 12 -1.04907e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 11.9999C24.0004 6.84023 20.7439 2.44176 16.1743 0.746198L16.1743 23.2534C20.7439 21.5579 24.0004 17.1594 24.0004 11.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15557e-05 11.9999C7.11047e-05 17.1594 3.25657 21.5579 7.82617 23.2534L7.82617 0.746153C3.25657 2.44176 7.20068e-05 6.84023 7.15557e-05 11.9999Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1679_4350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNGflagSelect);
export default __webpack_public_path__ + "static/media/NGflag-select.c3b6b23a4158c165e8613c36f3217aa6.svg";
export { ForwardRef as ReactComponent };